export const GET_ICONS = "GET_ICONS";
export const RESET_ICONS = "RESET_ICONS";
export const SET_ICONS_REQUEST_STATUS = "SET_ICONS_REQUEST_STATUS";
